module.exports = __webpack_public_path__ + "media/images/logo_square-4fb4aa31.png";